
import axios from 'axios';
import {Spin,Message} from 'iview';
//超时时间
axios.defaults.timeout = 300000;

//http请求拦截器
let loadingStatus;
axios.interceptors.request.use(config => {
//  loadingStatus
//   loadingStatus = Spin.show();
  // config.params.page = 0;
  // config.params.sort = '';
  // config.params.size = 10;
  config.headers = {
    "IVY-VERSION": "V2018.09.25",
    "IVY-TOKEN": sessionStorage.getItem("token") ? sessionStorage.getItem("token"): null,
    "IVY-SCHOOL-ID":sessionStorage.getItem("schoolId") ? sessionStorage.getItem("schoolId"): 0,
    "IVY-CLASS-ID":sessionStorage.getItem("classId") ? sessionStorage.getItem("classId"): 0,
  };
  return config
},error => {
  // Spin.hide();
  Message.error({
    content: "请求超时，请稍后再试",
    duration: 3,
    closable: true
  });
  return Promise.reject(error);
});

//相应拦截
axios.interceptors.response.use(res => {
  // Spin.hide();
  if(res.data.code !== 0) {
    Message.info({
      content: res.data.message,
      closeable:true,
      duration: 5,
    })
  }
  return res
}, error => {
  // Spin.hide();
  // console.log("err", error.response.data.message);
  // console.log("err",error.response.status);
  switch(error.response.status){
    case 401:
      this.$router.replace('/');
      break;
  }
  Message.error({
    content: error.response.data.message ||"请求错误",
    duration: 3,
    closable: true
  });
  return Promise.reject(error);
});
export default axios



// WEBPACK FOOTER //
// ./src/api/http.js